import React, { ReactElement, useState } from "react";
import { IBaseTag } from "@common/redux/types/tags";
import styles from "./FilterTags.module.scss";
import classnames from "classnames";
import { Tag } from "@kursk/components/ui/Tag/Tag";
import _ from "lodash";
import { ShowAllTags } from "./ShowAllTags";

interface IProps {
  tags: IBaseTag[];
  onTagClick: (arg0: IBaseTag) => void;
  selected: number[];
  bordered?: boolean;
}

export const FilterTags = ({ tags, onTagClick, selected, bordered = true }: IProps): ReactElement => {
  const [isOpen, setOpen] = useState(false);
  const [isContentOverflown, setIsOverflown] = useState(false);

  const toggle = () => {
    setOpen(!isOpen);
  };

  return tags.length ? (
    <div className={classnames(
      bordered ? styles.tagsWrapper : styles.tagsWrapper_noBorder,
      isOpen && styles.opened,
    )}>
      <div
        ref={(element) => {
          if (!element) return;
          const { clientHeight } = element;
          setIsOverflown(clientHeight > 50);
        }}
        className={
          classnames(
            styles.wrapper,
            isOpen && styles.opened,
          )
        }
      >
        {tags.map((tag: IBaseTag) => (
          <Tag selected={_.includes(selected, tag._id)} tag={tag} onClick={onTagClick} key={tag._id}/>
        ))}
        {(isOpen && isContentOverflown) && <ShowAllTags
          className={styles.onlyXl}
          toggle={toggle}
          isOpen={isOpen}
        />}
      </div>
      {(!isOpen && isContentOverflown) && (
        <ShowAllTags
          className={styles.onlyXl}
          toggle={toggle}
          isOpen={isOpen}
        />
      )}
    </div>
  ) : null;
};
